import MainLayout from "@/layout/MainLayout.vue";
export default [
  {
    path: "/classList",
    component: MainLayout,
    name: "classList",
    redirect: "/classList/gradeList",
    meta: {
      title: "班级管理",
      icon: "profile",
    },
    // hidden: true,
    hideChildrenInMenu: true,
    children: [
      {
        path: "/classList/gradeList",
        name: "gradeList",
        component: () => import("@/views/ClassList/Grade"),
        meta: {
          title: "年级班级",
        },
      },
    ],
  },
];
